import { render, staticRenderFns } from "./lrCreateuser2.vue?vue&type=template&id=23b5c6aa"
import script from "./lrCreateuser2.vue?vue&type=script&lang=js"
export * from "./lrCreateuser2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports